import { pathJoin } from 'src/reducers/routing/utils'

export const createNavigationAppRoutesMap = (prefix: string) => ({
  'stop-list-customization': pathJoin(prefix)('stop-list-customization').chain,
})
